import { Button, Form, Input } from "antd";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
const { Item } = Form;
const VerificationForm = (props) => {
  const { state } = useLocation();
  const [formData, setFormData] = useState({
    numberOne: 0,
    numberTwo: 0,
    numberThree: 0,
    numberFour: 0,
  });

  const onSubmit = (data) => {
    // const code = Object.values(formData).join("");
    // console.log(code);
    setCounter(80);
    console.log(state.data);
  };

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [counter, setCounter] = useState(80);
  useEffect(() => {
    if (counter) {
      const interval = setInterval(() => {
        setCounter((prevState) => prevState - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [counter]);

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <p>An account activation link has been sent to your email</p>
        <p>{state.data && state.data}</p>
      </div>

      <Form onFinish={onSubmit} style={{ width: "70%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <Item name="numberOne">
            <Input
              name="numberOne"
              type="number"
              size="large"
              onChange={onChange}
              value={formData.numberOne}
              maxLength={1}
              style={{
                width: "80px",
                height: "80px",
                fontSize: "40px",
                borderRadius: "8px",
                border: "1px solid #D6BBFB",
              }}
            />
          </Item>
          <Item name="numberTwo">
            <Input
              name="numberTwo"
              type="number"
              size="large"
              onChange={onChange}
              value={formData.numberTwo}
              maxLength={1}
              style={{
                width: "80px",
                height: "80px",
                fontSize: "40px",
                borderRadius: "8px",
                border: "1px solid #D6BBFB",
              }}
            />
          </Item>
          <Item name="numberThree">
            <Input
              name="numberThree"
              type="number"
              size="large"
              onChange={onChange}
              value={formData.numberThree}
              maxLength={1}
              style={{
                width: "80px",
                height: "80px",
                fontSize: "40px",
                borderRadius: "8px",
                border: "1px solid #D6BBFB",
              }}
            />
          </Item>
          <Item name="numberFour">
            <Input
              name="numberFour"
              type="number"
              size="large"
              onChange={onChange}
              value={formData.numberFour}
              maxLength={1}
              style={{
                width: "80px",
                height: "80px",
                fontSize: "40px",
                borderRadius: "8px",
                border: "1px solid #D6BBFB",
              }}
            />
          </Item>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>
            {Math.floor(counter / 60) +
              ":" +
              (counter % 60 ? counter % 60 : "00")}
          </span>

          <p style={{ margin: "1rem 0" }}>
            Did you not receive the activation message?{" "}
          </p>
          <Button type="link" htmlType="submit">
            I order it again
          </Button>
        </div>
      </Form>
    </>
  );
};

export default VerificationForm;
